// extracted by mini-css-extract-plugin
export default {"style":"IntroWindow_style__lu109"};